(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["apps"] && !Shopify.designMode) return;
  try {
    

(() => {
  const start = () => {
    document.querySelectorAll('.hss-review-masonry').forEach(root => {
      if (root.dataset.hssMasonryReady) return;
      root.dataset.hssMasonryReady = 'true';
      let queued = false;
      const observed = new WeakSet();
      const schedule = () => {
        if (queued) return;
        queued = true;
        requestAnimationFrame(() => {
          queued = false;
          root.querySelectorAll('select option[value="lowest_rating"]').forEach(option => option.remove());
          root.querySelectorAll('.jdgm-review-card__name').forEach(name => {
            const text = name.textContent.trim();
            if (!text || /^anonymous$/i.test(text)) return;
            const initials = (text.match(/[\p{L}\p{N}]+/gu) || []).map(part => Array.from(part)[0].toLocaleUpperCase() + '.').join('');
            if (initials && text !== initials) name.textContent = initials;
          });
          root.querySelectorAll('.jdgm-review-card').forEach(card => {
            const product = card.querySelector('.jm-product-variant-card__product-link');
            if (!product) return;
            let visibleProduct = card.querySelector('.hss-review-product');
            if (!visibleProduct) {
              visibleProduct = document.createElement('button');
              visibleProduct.type = 'button';
              visibleProduct.className = 'hss-review-product';
              visibleProduct.addEventListener('click',event => { event.stopPropagation(); product.click(); });
              card.append(visibleProduct);
            }
            const label = product.textContent.trim() + ' ↗';
            if (visibleProduct.textContent !== label) visibleProduct.textContent = label;
            visibleProduct.setAttribute('aria-label',product.getAttribute('aria-label') || product.textContent.trim());
          });
          root.querySelectorAll('.jdgm-masonry-grid__container').forEach(grid => {
            const columns = matchMedia('(max-width: 767px)').matches ? 2 : 6;
            const gap = columns === 2 ? 10 : 16;
            const width = grid.getBoundingClientRect().width;
            if (!width) return;
            grid.classList.add('hss-masonry-positioned');
            const itemWidth = (width - gap * (columns - 1)) / columns;
            const heights = Array(columns).fill(0);
            let items = Array.from(grid.children);
            const sort = root.querySelector('select.jm-sort-filter__select')?.value;
            const rating = item => Number(item.querySelector('.jm-star-rating')?.getAttribute('aria-label')?.match(/^([0-5])\b/)?.[1] || 0);
            if (sort === 'pictures_first') items.sort((left,right) => rating(right) - rating(left));
            items.forEach(item => {
              item.style.setProperty('--hss-card-width', itemWidth + 'px');
              const column = heights.indexOf(Math.min(...heights));
              item.style.setProperty('--hss-card-x', (column * (itemWidth + gap)) + 'px');
              item.style.setProperty('--hss-card-y', heights[column] + 'px');
              heights[column] += item.getBoundingClientRect().height + gap;
              if (!observed.has(item)) {
                observed.add(item);
                sizes.observe(item);
              }
            });
            grid.style.setProperty('--hss-grid-height', Math.max(0, ...heights) - gap + 'px');
          });
        });
      };
      const sizes = new ResizeObserver(schedule);
      sizes.observe(root);
      new MutationObserver(schedule).observe(root, { childList: true, subtree: true });
      root.addEventListener('load', schedule, true);
      window.addEventListener('resize', schedule, { passive: true });
      schedule();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', start);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hss-customer-moments"] && !Shopify.designMode) return;
  try {
    
(() => {
  const start = () => {
    const reviews = document.querySelector('.hss-review-masonry');
    if (!reviews) return;
    document.querySelectorAll('[data-hss-moments]').forEach(section => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      const nativeVideos = document.querySelector('[id$="__1761302249e7fc08a6"]');
      const syncVideoMode = () => {
        const hasVideos = Boolean(nativeVideos?.querySelector('video, [aria-label*="play" i]'));
        section.hidden = hasVideos;
        section.dataset.mediaMode = hasVideos ? 'videos' : 'photos';
      };
      if (nativeVideos) {
        new MutationObserver(syncVideoMode).observe(nativeVideos,{childList:true,subtree:true,attributes:true,attributeFilter:['src','aria-label']});
      }
      syncVideoMode();
      const track = section.querySelector('.hss-moments__track');
      const count = section.querySelector('.hss-moments__count');
      const progress = section.querySelector('.hss-moments__progress span');
      const mobile = matchMedia('(max-width:767px)');
      const reduced = matchMedia('(prefers-reduced-motion:reduce)');
      let active = 2;
      let signature = '';
      let scheduled = false;
      let paused = reduced.matches;
      let inView = false;
      let pointerHeld = false;
      let resumeAfter = 0;
      const rotation = section.querySelector('[data-hss-rotation]');
      const showRotation = () => {
        rotation.textContent = paused ? '▶' : 'Ⅱ';
        rotation.setAttribute('aria-label',paused ? rotation.dataset.playLabel : rotation.dataset.pauseLabel);
        rotation.setAttribute('aria-pressed',String(paused));
      };
      const deferRotation = () => { resumeAfter = Date.now() + 10000; };
      showRotation();
      const paint = () => {
        const cards = Array.from(track.children);
        if (!cards.length) return;
        active = ((active % cards.length) + cards.length) % cards.length;
        cards.forEach((card,index) => {
          let offset = (index - active + cards.length) % cards.length;
          if (offset > cards.length / 2) offset -= cards.length;
          const distance = Math.abs(offset);
          card.style.setProperty('--moment-offset',offset);
          card.style.setProperty('--moment-scale',1 - Math.min(distance,3) * .095);
          card.style.setProperty('--moment-lift',Math.min(distance,3) * 10 + 'px');
          card.style.zIndex = String(10 - distance);
          card.dataset.momentDistance = String(distance);
          card.setAttribute('aria-hidden',String(!mobile.matches && distance > 2));
          card.tabIndex = !mobile.matches && distance > 2 ? -1 : 0;
        });
        count.textContent = String(active + 1).padStart(2,'0') + ' / ' + String(cards.length).padStart(2,'0');
        progress.style.width = ((active + 1) / cards.length * 100) + '%';
      };
      const move = (direction,automatic = false) => {
        if (!automatic) deferRotation();
        if (mobile.matches) {
          const card = track.firstElementChild;
          if (!card) return;
          const maxScroll = track.scrollWidth - track.clientWidth;
          if (automatic && track.scrollLeft >= maxScroll - 2) {
            track.scrollTo({left:0,behavior:reduced.matches ? 'auto' : 'smooth'});
          } else {
            track.scrollBy({left:direction * (card.getBoundingClientRect().width + 10),behavior:reduced.matches ? 'auto' : 'smooth'});
          }
        } else { active += direction; paint(); }
      };
      const update = () => {
        scheduled = false;
        const sources = Array.from(reviews.querySelectorAll('.jdgm-review-card')).filter(card => card.querySelector('.jdgm-review-card__media-cover img')).sort((left,right) => {
          const rating = card => Number(card.querySelector('.jm-star-rating')?.getAttribute('aria-label')?.match(/^([0-5])\b/)?.[1] || 0);
          return rating(right) - rating(left);
        }).slice(0,12);
        const next = sources.map(card => card.querySelector('.jdgm-review-card__media-cover img').getAttribute('src') + ':' + (card.querySelector('.jdgm-review-card__name')?.textContent || '')).join('|');
        if (!next || signature === next) return;
        signature = next;
        track.replaceChildren();
        sources.forEach(card => {
          const originalImage = card.querySelector('.jdgm-review-card__media-cover img');
          const originalButton = card.querySelector('.jdgm-review-card__media-cover [role="button"]');
          const name = card.querySelector('.jdgm-review-card__name')?.textContent.trim() || '';
          const ratingLabel = card.querySelector('.jm-star-rating')?.getAttribute('aria-label') || '';
          const rating = Number(ratingLabel.match(/^([0-5])\b/)?.[1]);
          const link = document.createElement('a');
          link.className = 'hss-moments__card';
          link.setAttribute('role','listitem');
          link.href = '#' + reviews.closest('[id]').id;
          const image = document.createElement('img');
          image.src = originalImage.currentSrc || originalImage.src;
          image.alt = originalImage.alt;
          image.loading = 'lazy';
          link.append(image);
          const open = document.createElement('span');
          open.className = 'hss-moments__open';
          open.textContent = '↗';
          open.setAttribute('aria-hidden','true');
          link.append(open);
          const caption = document.createElement('span');
          caption.className = 'hss-moments__caption';
          if (Number.isFinite(rating) && ratingLabel) {
            const stars = document.createElement('span');
            stars.className = 'hss-moments__stars';
            stars.textContent = '★'.repeat(rating) + '☆'.repeat(5 - rating);
            stars.setAttribute('aria-label',ratingLabel);
            caption.append(stars);
          }
          if (name) {
            const label = document.createElement('span');
            label.className = 'hss-moments__name';
            label.textContent = name;
            caption.append(label);
          }
          const productName = card.querySelector('.jm-product-variant-card__product-link')?.textContent.trim();
          if (productName) {
            const product = document.createElement('span');
            product.className = 'hss-moments__product';
            product.textContent = productName;
            caption.append(product);
          }
          link.setAttribute('aria-label',[name,productName,'View review'].filter(Boolean).join(' · '));
          link.append(caption);
          link.addEventListener('click',event => {
            if (originalButton?.isConnected) { event.preventDefault(); originalButton.click(); }
          });
          track.append(link);
        });
        active = mobile.matches ? 0 : Math.min(2,sources.length - 1);
        paint();
      };
      section.querySelectorAll('[data-hss-direction]').forEach(button => button.addEventListener('click',() => move(Number(button.dataset.hssDirection))));
      section.addEventListener('keydown',event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); move(event.key === 'ArrowLeft' ? -1 : 1); }
      });
      track.addEventListener('scroll',() => {
        if (!mobile.matches || scheduled) return;
        scheduled = true;
        requestAnimationFrame(() => {
          scheduled = false;
          const card = track.firstElementChild;
          if (!card) return;
          active = Math.round(track.scrollLeft / (card.getBoundingClientRect().width + 10));
          paint();
        });
      },{passive:true});
      mobile.addEventListener('change',() => {
        if (mobile.matches && track.firstElementChild) active = Math.round(track.scrollLeft / (track.firstElementChild.getBoundingClientRect().width + 10));
        paint();
      });
      new MutationObserver(() => {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(update);
      }).observe(reviews,{childList:true,subtree:true});
      rotation.addEventListener('click',() => { paused = !paused; deferRotation(); showRotation(); });
      section.addEventListener('pointerdown',() => { pointerHeld = true; deferRotation(); });
      const releasePointer = () => { if (pointerHeld) { pointerHeld = false; deferRotation(); } };
      window.addEventListener('pointerup',releasePointer);
      window.addEventListener('pointercancel',releasePointer);
      section.addEventListener('focusin',deferRotation);
      section.addEventListener('focusout',deferRotation);
      track.addEventListener('wheel',deferRotation,{passive:true});
      const visibility = new IntersectionObserver(entries => { inView = entries[0].isIntersecting; },{threshold:.25});
      visibility.observe(section);
      const timer = setInterval(() => {
        if (!section.isConnected) { cleanup(); return; }
        if (paused || reduced.matches || !inView || document.hidden || section.hidden || pointerHeld || Date.now() < resumeAfter) return;
        if (section.contains(document.activeElement) || (matchMedia('(hover:hover)').matches && section.matches(':hover'))) return;
        if (Array.from(document.querySelectorAll('[role="dialog"][aria-modal="true"], .jdgm-review-widget-modal')).some(dialog => dialog.getClientRects().length && getComputedStyle(dialog).visibility !== 'hidden')) return;
        if (track.children.length < 2 || (mobile.matches && track.scrollWidth <= track.clientWidth + 2)) return;
        move(1,true);
      },5000);
      const onReducedChange = () => { if (reduced.matches) { paused = true; showRotation(); } };
      reduced.addEventListener('change',onReducedChange);
      const onUnload = event => { if (event.target.contains(section)) cleanup(); };
      const cleanup = () => {
        clearInterval(timer);
        visibility.disconnect();
        window.removeEventListener('pointerup',releasePointer);
        window.removeEventListener('pointercancel',releasePointer);
        reduced.removeEventListener('change',onReducedChange);
        document.removeEventListener('shopify:section:unload',onUnload);
      };
      document.addEventListener('shopify:section:unload',onUnload);
      update();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start,{once:true});
  else start();
  document.addEventListener('shopify:section:load',start);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();
})();
